export default "__VITE_ASSET__Bn$RelA8__"